import type { SurveyScopeFilters, SurveySettings } from '@g17eco/types/survey';


export type InitialFilters = Omit<SurveySettings, 'groupBy' | 'viewLayout'>;
export const initialFilters: InitialFilters = {
  filterByStatus: [],
  filterByDelegationStatus: [],
  filterByGoal: [],
  filterByRegulatory: [],
  filterByModules: [],
  filterByRole: [],
  filterByUser: [],
  filterByTag: [],
  searchText: '',
  filterByBookmarks: false,
};

export const initialScopeFilters: SurveyScopeFilters = {
  filterByMateriality: [],
}


